/* eslint-disable indent */
import normalAxios from 'axios';
import qs from 'qs';
import { request } from '../request';

const common = {
  // 获取登录后加载的配置 配置与用户信息有关，登录后需要刷新接口
  getPublicSetting: () => request('/api/public/setting', 'get'),
  // 常用国家列表
  commonCountry: (data) => request('/api/public/common_country', 'get', data),
  // 所有国家列表
  countryList: () => request('/api/public/country', 'get', {}),
  // 根据 ip 获取国家
  ipCountry: () => request('/api/public/ip_country', 'get', {}),
  recommend: (data) => request('/api/public/recommend_products', 'get', data), // 获取各个版块的推荐
  // 根据sku获取试戴数据
  tryOn(data) {
    return normalAxios.post('https://tryon.nextmar.com/api/tryon/get_sku_info', qs.stringify(data));
  },
  /* 试戴上传图片并获取定位信息 */
  uploadTryOnImg(data) {
    return normalAxios.post(
      'https://tryon.nextmar.com/api/tryon/photo_upload_base64',
      qs.stringify(data),
    );
  },
  // 试戴上传（参数为文件格式）
  uploadTryOnImgFile(data) {
    return normalAxios.post('https://tryon.nextmar.com/api/tryon/photo_upload_form', data);
  },
  getSmsLink: (data) => request('/api/public/get_sms_link', 'get', data), // 获取短信链列表
  setCj: (data) => request('/api/customer/set_cj_assigned', 'post', data), // 检测到cj标识（保存30天），且用户登录，则传给接口，让app使用
  klarnaSave: () => request('/api/public/get_reduce_for_klarna_pay', 'get', {}), // klarna 支付优惠
  // 获取用户版本信息
  getVersion() {
    const t = Date.now();
    return normalAxios(`/version.json?t=${t}`);
  },
  // 根据utm参数领取优惠券
  getCouponUtm: (data) =>
    request('/api/customer/get_coupon_utm', 'post', data, {
      successMsg: false,
      errorMsg: true,
    }),
  // 日志收集
  collectError: (data, config = {}, headers = {}) =>
    request('/api/public/collect_error', 'post', data, config, headers),
  // 邮件退订
  emailUnsubscribe: (data) => request('/api/customer/unsubscribe_email', 'post', data),
  // 删除账户发送验证码
  logOffSendCode: (data) =>
    request('/api/customer/log_off_send_code', 'post', data, {
      successToast: false,
      errorMsg: true,
    }),
  // 删除账户
  logOff: (data) =>
    request('/api/customer/log_off', 'post', data, { successToast: false, errorMsg: true }),
  // 绑定impact
  bindImpact: (data) =>
    request('/api/customer/bind_impact', 'get', data, { successToast: false, errorMsg: false }),
  // 绑定awin
  bindAwin: (data) =>
    request('/api/customer/bind_awin', 'get', data, { successToast: false, errorMsg: false }),
  /* 获取contact-us主题列表的数据 */
  getContactUsSubjectList: (data) => request('/api/public/contact_us_subject/lists', 'get', data),
  // 获取后台配置jsonvalue
  getBlockValue: (data) => request('/api/block_config/get_block_value', 'post', data),

  // webpush 神策-灰度策略
  webPushGrayscaleStrategy: () => request('/api/public/sensors/grayscale_strategy'),
  // 通用配置接口（接口根据传参返回对应数据）
  getPublicResources: (data) => request('/api/public/resources', 'post', data),
  filterStatistics: (data) => request('/api/products/filter_statistics', 'post', data),
  getABTest: (data) => request('/api/ab_test', 'get', data), // 全局AB测试接口
  // WriteForUs提交接口
  writeForUsApplication: (data) =>
    request('/api/write_for_us/create', 'post', data, {
      successToast: false,
      successMsg: true,
      errorMsg: true,
    }),
};
export default common;
